import { render, staticRenderFns } from "./WallElements.vue?vue&type=template&id=e3e84032&"
import script from "./WallElements.vue?vue&type=script&lang=js&"
export * from "./WallElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports